/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './animation039.less';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation039Item {
  icon: string;
  title: string;
  content: string;
}

const getImg = (img: string) => require(`../../../../../assets/${img}`).default;

interface IAnimation039Props {
  items: IAnimation039Item[];
  onCompleted?: () => void;
  className?: string;
}

const Animation039: React.FunctionComponent<IAnimation039Props> = ({
  className,
  items,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  return (
    <div ref={crrRef} className={`animation039 component ${className}`}>
      {items.map((itm: IAnimation039Item, idx: number) => (
        <div
          key={idx}
          className={`animation039-item animation ${
            play >= idx + 1 ? 'fade-in' : ''
          }`}
          onClick={() => startPlay()}
        >
          <img
            className={`click-point ${play > 1 ? 'hide' : ''}`}
            src={ImgPoint}
            alt=""
          />

          <div className="animation039-icon">
            <img src={getImg(itm.icon)} alt="" />
          </div>

          <div
            className="animation039-title"
            dangerouslySetInnerHTML={{ __html: itm.title }}
          />

          <div
            className="animation039-text"
            dangerouslySetInnerHTML={{ __html: itm.content }}
          />
        </div>
      ))}
    </div>
  );
};

export default Animation039;
